import React from 'react';
import { useIntl } from 'react-intl';

import { SMSProviders } from '../../../api';
import { SMS_LINKS } from '../../../constants';
import { FieldInput } from '../../ui';
import {
  DescriptionLink,
  FieldWrapper,
  ProviderSubtitle,
  ProviderTitle,
  SmsProviderFieldsCard,
  SmsProviderHeader
} from '../style';
import { SMSProviderStatus } from './SMSProviderStatus';
import { ProviderFieldProps } from './types';
import { maxFieldLength, maxPhoneNumberLength } from './validator';

export const TelnyxFields = ({ errors, providerData }: ProviderFieldProps): JSX.Element => {
  const intl = useIntl();
  const { TELNYX_API, TELNYX_SENDER } = SMS_LINKS;

  const getError = (field: string): string => {
    if (errors[SMSProviders.telnyx][field]) {
      return intl.formatMessage(
        { id: errors[SMSProviders.telnyx][field] as string },
        {
          number: field === 'phone_number' ? maxPhoneNumberLength : maxFieldLength
        }
      );
    }

    return '';
  };

  return (
    <SmsProviderFieldsCard data-test-id="sms-provider-fields-card-telnyx">
      <SmsProviderHeader>
        <ProviderTitle>
          {intl.formatMessage({ id: 'custom-providers.settings.sms.provider.telnyx.label' })}
        </ProviderTitle>
        <SMSProviderStatus
          providerData={providerData}
          dataTestId="sms-provider-telnyx-status-button"
        />
      </SmsProviderHeader>
      <ProviderSubtitle>
        {intl.formatMessage(
          { id: 'custom-providers.settings.sms.provider.telnyx.description' },
          {
            a: (chunk: string) => (
              <DescriptionLink href={TELNYX_API} target="_blank">
                {chunk}
              </DescriptionLink>
            )
          }
        )}
      </ProviderSubtitle>
      <FieldWrapper>
        <FieldInput
          label={intl.formatMessage({
            id: 'custom-providers.settings.sms.provider.telnyx.api-key.label'
          })}
          errorMessage={getError('app_secret')}
          name={`fields.${SMSProviders.telnyx}.app_secret`}
        />
      </FieldWrapper>
      <FieldWrapper>
        <FieldInput
          label={intl.formatMessage({
            id: 'custom-providers.settings.sms.provider.telnyx.phone.label'
          })}
          errorMessage={getError('phone_number')}
          name={`fields.${SMSProviders.telnyx}.phone_number`}
        />
      </FieldWrapper>
      <FieldWrapper>
        <FieldInput
          label={intl.formatMessage({
            id: 'custom-providers.settings.sms.provider.sender-id.label'
          })}
          subLabel={intl.formatMessage(
            {
              id: 'custom-providers.settings.sms.provider.sender-id.sublabel'
            },
            {
              a: (chunk: string) => (
                <DescriptionLink href={TELNYX_SENDER} target="_blank">
                  {chunk}
                </DescriptionLink>
              )
            }
          )}
          errorMessage={getError('sender_id')}
          name={`fields.${SMSProviders.telnyx}.sender_id`}
        />
      </FieldWrapper>
      <FieldWrapper>
        <FieldInput
          label={intl.formatMessage({
            id: 'custom-providers.settings.sms.provider.telnyx.app-id.label'
          })}
          errorMessage={getError('app_id')}
          name={`fields.${SMSProviders.telnyx}.app_id`}
        />
      </FieldWrapper>
    </SmsProviderFieldsCard>
  );
};
